import PropTypes from "prop-types";
import * as React from "react";
import { statusOf } from "../../utils/propTypes";
import css from "./Badge.module.css";

const formatCount = (n) => (n > 99 ? "99+" : String(n));

const Badge = React.forwardRef(
  (
    {
      variant = "dot",
      tone = "error",
      count,
      status,
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    if (variant === "count" && (!count || count <= 0)) return null;

    const classes = [
      variant === "dot" && css.dot,
      variant === "count" && css.count,
      variant === "count" && tone === "neutral" && css["tone-neutral"],
      variant === "status" && status && css[`status-${status}`],
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <span ref={ref} className={classes} {...rest}>
        {variant === "count" && formatCount(count)}
        {variant === "status" && children}
      </span>
    );
  },
);

Badge.displayName = "Badge";

Badge.propTypes = {
  variant: PropTypes.oneOf(["dot", "count", "status"]),
  tone: PropTypes.oneOf(["error", "neutral"]),
  count: PropTypes.number,
  status: statusOf(
    "unavailable",
    "vaulted",
    "pending",
    "critical",
    "success",
    "featured",
    "vip",
    "info",
  ),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Badge;
